import React, {Component} from 'react';
import * as actions from "../../store/actions";
import connect from "react-redux/es/connect/connect";
import CircularProgress from "@material-ui/core/CircularProgress/CircularProgress";
import {arrayToDataTable} from "../../config/Utils";
import Chart from "react-google-charts";

class CompanyRecentlyApproved extends Component {

    state = {
        companyName: "",
        periodSize: 3
    };

    componentDidMount() {
        let companyName = this.props.history.location.state && this.props.history.location.state.companyName;
        if (!companyName) {
            this.props.history.goBack();
        }
        this.setState({companyName});
        this.props.loadTimeline(companyName);
    }

    prepareIntervals() {
        let periodSize = this.state.periodSize;
        if (!periodSize || periodSize <= 0) {
            periodSize = 1;
        }
        let intervals = [];
        let todayYear = new Date().getFullYear();
        let yearCountPairs = this.props.timeline.drugsCountPerYear;
        if (yearCountPairs.length === 0)
            return undefined;
        let minYear = parseInt(yearCountPairs[0].countryCode);
        for (let i = minYear; i < todayYear; i += periodSize) {
            let totalDrugsInPeriod = 0;
            let startPeriod = i;
            let endPeriod = (startPeriod + periodSize) > todayYear ? todayYear : (startPeriod + periodSize);
            for (let j = startPeriod; j < endPeriod && j < todayYear; j++) {
                let year = yearCountPairs.filter(y => y.countryCode === j.toString())[0];
                if (year) {
                    totalDrugsInPeriod += year.count;
                }
            }
            intervals.push({
                interval: i + "-" + endPeriod,
                periodDrugCount: totalDrugsInPeriod
            })
        }
        return intervals;
    }

    renderEvents = () => {
        let totalNumberOfDrugs = this.props.timeline.totalDrugs;
        let data = this.prepareIntervals() ? this.prepareIntervals().reverse() : null;
        if (!data) {
            return (
                <div className='vertical-timeline-block'>
                    <div className="vertical-timeline-icon bg-danger">
                    </div>
                    <div className='vertical-timeline-content'>
                        <h4>No available data</h4>
                        {this.state.companyName} has a total of {totalNumberOfDrugs} registered drugs
                    </div>
                </div>
            );
        }
        let index = 0;
        return data.map(item => {
            index++;
            const percent = (item.periodDrugCount * 100 / totalNumberOfDrugs).toFixed(2);
            if (percent > 1)
                return (
                    <div className='vertical-timeline-block' key={index}>
                        <div className="vertical-timeline-icon bg-success">
                            <h6 className='p-1 text-white font-weight-bold'>{item.interval}</h6>
                        </div>
                        <div className='vertical-timeline-content'>
                            <h4>Number of registered drugs: {item.periodDrugCount}</h4>
                            {percent}% of all drugs were registered this year
                        </div>
                    </div>
                );
            else return null;
        });
    };

    handlePeriodChange = (e) => {
        const newSize = e.target.value;
        if (newSize > 0) {
            this.setState((old) => {
                return {
                    companyName: old.companyName,
                    periodSize: parseInt(newSize)
                }
            });
        }
    };

    renderChart = () => {
        const data = arrayToDataTable(this.prepareIntervals(), ['Period', 'Drug Count']);
        const title = `This manufacturer has a total of ${this.props.timeline.totalDrugs} registered drugs`;
        if (!data || data.length === 0)
            return <h3>No available data</h3>;
        return (
            <div className='w-100'>
                <div className="form-group w-25 d-block">
                    <label htmlFor='per-size'>Change period length</label>
                    <input value={this.state.periodSize}
                           onChange={this.handlePeriodChange}
                           type='number'
                           className='form-control'
                           id='per-size'
                    />
                </div>
                <Chart chartType={'AreaChart'}
                       data={data}
                       height={'450px'}
                       width={'100%'}
                       options={{
                           title: title,
                           chartArea: {width: '80%'},
                           legend: {position: 'none'}
                       }}
                >
                </Chart>
            </div>
        )
    };

    render() {
        if (this.props.loading || !this.props.timeline) {
            return (
                <div className='d-flex align-items-center justify-content-center' style={{minHeight: '60vh'}}>
                    <CircularProgress/>
                </div>
            )
        }
        return (
            <div className='row' style={{minHeight: '60vh'}}>
                <div className="col-6 pr-3 ibox">
                    <div className="ibox-title">
                        <h4>Vertical timeline for recently approved drugs</h4>
                    </div>
                    <div className="ibox-content">
                        <div className="vertical-container dark-timeline">
                            {this.renderEvents()}
                        </div>
                    </div>
                </div>
                <div className='col-6 ibox'>
                    <div className="ibox-title">
                        <h4>Approved drugs per period</h4>
                    </div>
                    <div className="ibox-content">
                        {this.renderChart()}
                    </div>
                </div>
            </div>
        );
    }
}


const mapDispatchToProps = dispatch => {
    return {
        loadTimeline: (name) => dispatch(actions.loadTimeline(name)),
    }
};


const mapStateToProps = state => {
    return {
        timeline: state.company.timeline,
        loading: state.company.loading
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyRecentlyApproved);
